"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __spreadArrays = this && this.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
    s += arguments[i].length;
  }

  for (var r = Array(s), k = 0, i = 0; i < il; i++) {
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
      r[k] = a[j];
    }
  }

  return r;
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var ksys_app_template_1 = require("@kurtosys/ksys-app-template");

var react_socks_1 = __importDefault(require("react-socks"));

var mobx_react_1 = require("mobx-react");

var shared_1 = require("../../../shared");

var Wrapper_1 = __importDefault(require("./styledComponents/Wrapper"));

var Award_1 = __importDefault(require("../Award/Award"));

var AwardWrapper_1 = __importDefault(require("./styledComponents/AwardWrapper"));

var Awards_meta_1 = require("./Awards.meta");

var Carousel_1 = __importDefault(require("../../base/Carousel"));

var mobx_1 = require("mobx");

var sortByFunction = ksys_app_template_1.utils.collection.sortBy;

var Awards =
/** @class */
function (_super) {
  __extends(Awards, _super);

  function Awards(props) {
    var _this = _super.call(this, props) || this;

    _this.categoryKey = Awards_meta_1.AWARDS_CATEGORY_KEY;
    _this.componentKey = Awards_meta_1.AWARDS_COMPONENT_KEY;
    _this.awards = [];

    _this.setHidden = function (award, index) {
      _this.awards[index] = __assign(__assign({}, award), {
        hidden: true,
        loaded: true
      });
      _this.awards = __spreadArrays(_this.awards);
    };

    _this.setLoaded = function (index) {
      _this.awards[index].loaded = true;
      _this.awards = __spreadArrays(_this.awards);
    };

    var _a = props.awards,
        awards = _a === void 0 ? [] : _a;
    _this.awards = __spreadArrays(awards.map(function (award, index) {
      return __assign(__assign({}, award), {
        imageProps: __assign(__assign({}, award.imageProps), {
          onError: function onError() {
            _this.setHidden(award, index);
          },
          onLoad: function onLoad() {
            _this.setLoaded(index);
          }
        })
      });
    }));
    return _this;
  }

  Awards.prototype.imagesLoaded = function (hideAwardsWithNoImages) {
    if (hideAwardsWithNoImages) {
      return this.awards.every(function (award) {
        return award.loaded;
      });
    }

    return true;
  };

  Awards.prototype.getSortedAwards = function (awards, sortBy) {
    if (ksys_app_template_1.utils.typeChecks.isNullOrUndefined(sortBy)) {
      return awards;
    }

    return sortByFunction(awards, sortBy, 'ASC');
  };

  Awards.prototype.getAwardsCarousel = function (props) {
    var carouselProps = props.carouselProps;
    return react_1.default.createElement(Carousel_1.default, __assign({}, carouselProps || {}), this.getAwards(props));
  };

  Awards.prototype.getValidAwards = function (awards) {
    return awards.filter(function (award) {
      return !award.hidden;
    });
  };

  Awards.prototype.getAwards = function (props) {
    var hideAwardsWithNoImages = props.hideAwardsWithNoImages,
        sortBy = props.sortBy;
    var awards = this.awards;

    if (hideAwardsWithNoImages) {
      awards = this.getValidAwards(awards);
    }

    awards = this.getSortedAwards(awards, sortBy);
    return awards.map(function (award, index) {
      var order = award.order,
          awardProps = __rest(award, ["order"]);

      if (props.textProps) {
        awardProps.textProps = ksys_app_template_1.utils.object.deepMergeObjects(props.textProps, awardProps.textProps);
      }

      return react_1.default.createElement(AwardWrapper_1.default, {
        key: "award_" + index
      }, react_1.default.createElement(Award_1.default, __assign({}, awardProps)));
    });
  };

  Awards.prototype.render = function () {
    var _this = this;

    var breakpoints = this.breakpoints;
    return react_1.default.createElement(react_1.Fragment, null, breakpoints.map(function (breakpoint, breakpointIndex) {
      var props = breakpoint.props;

      if (props) {
        var breakpointProps = _this.getBreakpointComponentProps(breakpoint, breakpointIndex);

        var className = props.className,
            useCarousel = props.useCarousel,
            hideAwardsWithNoImages = props.hideAwardsWithNoImages;
        return react_1.default.createElement(react_socks_1.default, __assign({}, breakpointProps), react_1.default.createElement(Wrapper_1.default, {
          className: className,
          style: {
            visibility: _this.imagesLoaded(hideAwardsWithNoImages) ? "visible" : "hidden"
          }
        }, useCarousel ? _this.getAwardsCarousel(props) : _this.getAwards(props)));
      }
    }));
  };

  __decorate([mobx_1.observable], Awards.prototype, "awards", void 0);

  __decorate([mobx_1.action], Awards.prototype, "setHidden", void 0);

  __decorate([mobx_1.action], Awards.prototype, "setLoaded", void 0);

  Awards = __decorate([mobx_react_1.observer], Awards);
  return Awards;
}(shared_1.ResponsiveComponentBase);

exports.Awards = Awards;
exports.default = shared_1.InjectedStyledComponent(Awards, Awards_meta_1.AWARDS_CATEGORY_KEY, Awards_meta_1.AWARDS_COMPONENT_KEY);